import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=26a35194&scoped=true&"
import script from "./topBanner.vue?vue&type=script&lang=js&"
export * from "./topBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a35194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a35194')) {
      api.createRecord('26a35194', component.options)
    } else {
      api.reload('26a35194', component.options)
    }
    module.hot.accept("./topBanner.vue?vue&type=template&id=26a35194&scoped=true&", function () {
      api.rerender('26a35194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/topBanner.vue"
export default component.exports